<template>
  <div class="tc-container">
    <ul>
      <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
        今日
      </li>
      <li :class="actvIndex == 2 ? 'is-active' : ''" @click="handSelect(2)">
        近七天
      </li>
      <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
        本月
      </li>
      <li :class="actvIndex == 4 ? 'is-active' : ''" @click="handSelect(4)">
        本年
      </li>
    </ul>
    <div ref="myChart" class="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        colorList: [
          ['#0f1819', '#f07317'],
          ['#0d1719', '#f0de17'],
          ['#0d181a', '#17f08c'],
          ['#0d1619', '#17f0de'],
          ['#0d171a', '#17bff0'],
        ],
        actvIndex: 3,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      handSelect(i) {
        this.actvIndex = i
      },
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = {
          grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            top: '10%',
            containLabel: true,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none',
            },
            formatter: function (params) {
              return (
                params[0].name +
                '<br/>' +
                "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
                params[0].seriesName +
                ' : ' +
                Number(
                  (params[0].value.toFixed(4) / 10000).toFixed(2)
                ).toLocaleString() +
                ' 万元<br/>'
              )
            },
          },
          xAxis: {
            show: false,
            type: 'value',
          },
          yAxis: [
            {
              type: 'category',
              inverse: true,
              axisLabel: {
                fontSize: 14,
                //给坐标名添加颜色属性
                textStyle: {
                  color: function (params, index) {
                    let colorList = [
                      '#FF0000',
                      '#FFAE00',
                      '#02FFA3',
                      '#FFFFFF',
                      '#FFFFFF',
                    ]
                    return colorList[index]
                  },
                },
              },
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              data: [
                'TOP.1 喀什地',
                'TOP.2 塔城地',
                'TOP.3 哈密市',
                'TOP.4 吐鲁番',
                'TOP.5 伊犁哈',
              ],
            },
            {
              type: 'category',
              inverse: true,
              axisTick: 'none',
              axisLine: 'none',
              show: true,
              axisLabel: {
                textStyle: {
                  color: '#ffffff',
                  fontSize: '12',
                },
                formatter: function (value) {
                  if (value >= 10000) {
                    return (value / 10000).toLocaleString()
                  } else {
                    return value.toLocaleString()
                  }
                },
              },
              data: [63, 58, 39, 33, 16],
            },
          ],
          series: [
            {
              name: '金额',
              type: 'bar',
              zlevel: 1,
              itemStyle: {
                normal: {
                  barBorderRadius: 30,
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0,
                      color: '#FFAE00',
                    },
                    {
                      offset: 1,
                      color: '#FFAE00',
                    },
                  ]),
                },
              },
              barWidth: 8,
              data: [13, 23, 44, 51, 13],
            },
            {
              name: '背景',
              type: 'bar',
              barWidth: 8,
              barGap: '-100%',
              data: [100, 100, 100, 100, 100],
              itemStyle: {
                normal: {
                  color: 'rgba(255, 174, 0, 0.3)',
                  barBorderRadius: 30,
                },
              },
            },
          ],
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;
      li {
        margin-right: 30px;
        white-space: nowrap;
      }
      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;
        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 37%;
        }
      }
    }
    .myChart {
      width: 100%;
      height: 21.3vh;
    }

    .tc-title {
      color: #e6e6e6;
      text-align: center;
      font-size: 12px;

      span {
        font-size: 1.1458vw;
        color: white;
      }
    }
  }
</style>
